export default "__VITE_ASSET__DAaYwej3__"